import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    postAdd,
    getParamsList,
    postEdit,
    postDelete,
    getList,
    patchImg,
    putImg,
    postFormData,
    addParams,
} from "../../../helpers/Helper";
import {
    RiCheckboxCircleLine,
    RiAlertLine,
    RiInformationLine,
} from "react-icons/ri";
import { serialize } from "object-to-formdata";

export const getJattuList = createAsyncThunk(
    "/getJattuList",
    async (payload) => {
        var data = payload;
        var params = {};

        for (const k in data) {
            if (Object.hasOwnProperty.call(data, k)) {
                if (k === "currentSort" || k === "sortOrder") {
                    params.ordering = data.sortOrder + data.currentSort;
                } else {
                    if (data[k] != "" && k != null && k != "no_of_pages") {
                        params[k] = data[k];
                    }
                }
            }
        }
        try {
            const response = await getParamsList("/masters/jattu/", params);
            if (response) {
                return { response };
            } else {
                throw new Error(response);
            }
        } catch (error) {
            throw error.message;
        }
    }
);
export const getJattuByID = createAsyncThunk(
    "/getJattuByID",
    async (payload) => {
        try {
            const response = await getList("/masters/jattu/" + payload + "/");
            return response.data;
        } catch (error) {
            throw error.message;
        }
    }
);
export const getJattuByCompany = createAsyncThunk(
    "/getJattuByCompany",
    async (payload) => {
        try {
            const response = await getList("/masters/jattu/?company=" + payload);
            return response.data;
        } catch (error) {
            throw error.message;
        }
    }
);